import backend from "../api/index";
import { useStore } from "@/store";
import { handleError } from "./handleErrors";

const useLoadFilters = async () => {
  const store = useStore();
  try {
    const { data } = await backend.index("/api/v3/users/filters", {});

    store.commit("updateFilters", data.filters);

    Object.keys(data.filters).forEach(key => {
      if (Object.keys(store.state.grid).includes(key)) {
        Object.keys(data.filters[key]).forEach(filter => {
          if (filter !== "query") {
            store.commit("updateFilter", { grid_name: key, filter: filter, value: data.filters[key][filter] });
          }
        });
        store.state.grid[key].query = data.filters[key]?.query ?? "";
      }
    });
  } catch (e) {
    await handleError(e);
  }
};

const useGetFilters = pageName => {
  const store = useStore();
  return store.state.filters[pageName];
};

const useUpdateFilters = async (gridName, filters) => {
  const store = useStore();

  try {
    if (filters === "remove") {
      filters = "delete";
    }

    const { data } = await backend.patch(
      `api/v3/users/filters/${gridName}`,
      { filter: filters },
      { jsonRequest: true },
    );

    store.commit("updateFilters", data.filters);
  } catch (e) {
    await handleError(e);
  }
};

export { useLoadFilters, useGetFilters, useUpdateFilters };
